import styled from 'styled-components'

export const Item = styled.p`
  margin-bottom: 8px !important;
`
export const Title = styled.p`
  font-weight: bold;
`
